<template>
  <div class="text-center">
    <h2 v-text="$t('title')"></h2>
    <v-row no-gutters justify="center">
      <v-radio-group
        v-model="$root.$i18n.locale"
        dense
        :dark="$vuetify.breakpoint.mdAndUp"
        row
      >
        <v-radio
          v-for="lang in langs"
          :key="lang.value"
          :label="lang.label"
          :value="lang.value"
          color="#82b1ff"
        ></v-radio>
      </v-radio-group>
    </v-row>
  </div>
</template>
<i18n>
{
  "ja": {
    "title": "言語設定"
  },
  "en": {
    "title": "Language Setting"
  }
}
</i18n>
<script>
import { LANG } from "@/enums/Lang";
import { UPDATE_SELECTED_LANG } from "@/store/mutation-types";

export default {
  name: "Settings",
  data() {
    return {
      langs: [
        { label: "日本語", value: LANG.JA },
        { label: "English", value: LANG.EN },
      ],
    };
  },
  computed: {
    selectedLang: {
      get() {
        return this.$store.state.selectedLang;
      },
      set(selectedLang) {
        this.$store.commit(UPDATE_SELECTED_LANG, { selectedLang });
      },
    },
  },
  created() {},
};
</script>

<style scoped></style>
